import { User } from "@/types/models/User.interface";
import { QueryParams } from "@/api";

export type EventRecordPostPayload = {
  event_name: string;
  data: Record<string, unknown>;
};

export interface EventRecordFilter extends QueryParams {
  event_name?: string;
}

export const eventRecordFilterMock: EventRecordFilter = {
  event_name: "user_active_session",
};

export type EventRecord = {
  user: Pick<User, "id" | "pk" | "unique_id">;
  event_name: string;
  date_created: string;
  data: Record<string, unknown>;
};

export const eventRecordMock: EventRecord[] = [
  {
    user: {
      id: 2054574170,
      pk: 2054574170,
      unique_id: "157b74a49166467bb6cda9ecf8812164",
    },
    event_name: "initial_teacher_onboarding_completed",
    date_created: "2024-11-08T06:18:47Z",
    data: {},
  },
  {
    user: {
      id: 2054574170,
      pk: 2054574170,
      unique_id: "157b74a49166467bb6cda9ecf8812164",
    },
    event_name: "repeat_teacher_onboarding_completed",
    date_created: "2024-11-08T06:18:47Z",
    data: {},
  },
  {
    user: {
      id: 2054574170,
      pk: 2054574170,
      unique_id: "157b74a49166467bb6cda9ecf8812164",
    },
    event_name: "individual_trial_teacher_onboarding_completed",
    date_created: "2024-11-08T06:18:47Z",
    data: {},
  },
  {
    user: {
      id: 2054574170,
      pk: 2054574170,
      unique_id: "157b74a49166467bb6cda9ecf8812164",
    },
    event_name: "initial_teacher_onboarding_completed",
    date_created: "2024-11-21T16:47:29Z",
    data: {
      onboarding_type: "premium",
    },
  },
  {
    user: {
      id: 2054574170,
      pk: 2054574170,
      unique_id: "157b74a49166467bb6cda9ecf8812164",
    },
    event_name: "initial_teacher_onboarding_completed",
    date_created: "2024-11-21T17:02:35Z",
    data: {
      onboarding_type: "premium",
    },
  },
  {
    user: {
      id: 2054574170,
      pk: 2054574170,
      unique_id: "157b74a49166467bb6cda9ecf8812164",
    },
    event_name: "initial_teacher_onboarding_completed",
    date_created: "2024-11-21T17:02:55Z",
    data: {
      onboarding_type: "premium",
    },
  },
];
